module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_12-93e9e2b677b8ab34fce0a7e717ae7ca6.png";